import {
  EMAIL_MAX_LENGTH,
  EMAIL_MIN_LENGTH,
  FIRST_NAME_MAX_LENGTH,
  LAST_NAME_MAX_LENGTH,
  PASSWORD_MAX_LENGTH,
  PASSWORD_MIN_LENGTH,
} from '../constraints/okta';

const validationErrorMessages = {
  maxLength: {
    email: `Email should not exceed ${EMAIL_MAX_LENGTH} characters.`,
    firstName: `First name should not exceed ${FIRST_NAME_MAX_LENGTH} characters.`,
    lastName: `Last name should not exceed ${LAST_NAME_MAX_LENGTH} characters.`,
    password: `Your password should not exceed ${PASSWORD_MAX_LENGTH} characters.`,
  },
  minLength: {
    email: `Email should not have less than ${EMAIL_MIN_LENGTH} characters.`,
    password: `Your password should not have less than ${PASSWORD_MIN_LENGTH} characters.`,
  },
  required: 'This field is required',
  string: {
    email: 'Please enter a valid email address',
    mobilePhone: 'Invalid US mobile phone number.',
    passwordMatch: 'Passwords must match.',
  },
};

export default validationErrorMessages;
